import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { StyledContainer, StyledIcon, StyledImage } from './PanoramicStyles';

import useWindowWidth from '../../hooks/useWindowWidth';

var _ref = React.createElement(StyledIcon, {
  src: 'https://cdn.shopify.com/s/files/1/1765/3959/files/180_icon_white.png?v=1587064923'
});

var Panoramic = function Panoramic(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      showIcon = _useState2[0],
      setShowIcon = _useState2[1];

  var windowWidth = useWindowWidth();
  var nonPano = props.nonPano;
  var scale = nonPano ? 1 : 1.2;

  return React.createElement(
    StyledContainer,
    {
      onTouchStart: function onTouchStart() {
        return setShowIcon(false);
      },
      onMouseDown: function onMouseDown() {
        return setShowIcon(false);
      },
      wide: !nonPano
    },
    React.createElement(
      TransformWrapper,
      {
        defaultScale: scale,
        zoomIn: {
          disabled: !nonPano
        },
        wheel: {
          touchPadEnabled: false
        },
        pan: {
          lockAxisY: true
        },
        pinch: {
          disabled: !nonPano
        },
        options: {
          disabled: nonPano,
          limitToBounds: true,
          limitToWrapper: false,
          minPositionX: 0,
          maxPositionX: 10
        },
        reset: {
          disabled: true,
          animation: false
        }
      },
      React.createElement(
        TransformComponent,
        null,
        React.createElement(StyledImage, { src: props.panoHeroImage, alt: 'test', wide: !nonPano })
      )
    ),
    !nonPano && showIcon && _ref
  );
};

Panoramic.propTypes = {
  panoHeroImage: PropTypes.string,
  nonPano: PropTypes.bool
};

export default Panoramic;